import React, { useState } from "react";
import infoImg from "styles/common/img/examplan/img-mission-first.webp";
import "./ExamPlanGuide.scss";

function ExamPlanGuide({ guideItems = [], initialMission = null }) {
    const [activeIndex, setActiveIndex] = useState(() => {
        const initialIndex = guideItems.findIndex((item) => item.mission === initialMission);
        return initialIndex >= 0 ? initialIndex : null;
    });

    const activeGuide = activeIndex === null ? null : guideItems[activeIndex];

    const orderedSections = activeGuide ? createOrderedSections(activeGuide) : [];

    return (
        <div className="expln-guide">
            <aside className="expln-guide__menu">
                <h2 className="expln-guide__menu-tit">미션 안내</h2>

                <ul className="expln-guide__menu-list">
                    {guideItems.map((item, index) => {
                        const isActive = activeIndex === index;

                        return (
                            <li className={`expln-guide__menu-item ${isActive ? "is-active" : ""}`} key={item.id}>
                                <button
                                    type="button"
                                    className={`expln-guide__menu-btn ${isActive ? "is-active" : ""}`}
                                    onClick={() => setActiveIndex(index)}
                                >
                                    {item.mission !== null && (
                                        <span className="expln-guide__menu-tag">MISSION {item.mission}</span>
                                    )}

                                    <span className="expln-guide__menu-lbl">{item.title}</span>

                                    <span className="expln-guide__menu-chevron" aria-hidden="true" />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </aside>

            <article
                className={`expln-guide__cont ${activeGuide ? "is-mission" : "is-notice"} expln-tab${activeIndex}`}
            >
                {!activeGuide ? (
                    <img className="expln-guide__info-img" src={infoImg} alt="미션을 선택해 주세요." />
                ) : (
                    <GuideContent guide={activeGuide} sections={orderedSections} />
                )}
            </article>
        </div>
    );
}

function GuideContent({ guide, sections }) {
    const isNoticeGuide = guide.mission === null;

    return (
        <>
            <header className="expln-guide__head">
                {!isNoticeGuide && <span className="expln-guide__tag">MISSION {guide.mission}</span>}

                <h2
                    className="expln-guide__tit"
                    dangerouslySetInnerHTML={{
                        __html: formatSubtitle(guide.subtitle),
                    }}
                />
            </header>

            <div className="expln-guide__line" />

            <div className="expln-guide__body">
                {sections.map((section, sectionIndex) => (
                    <section
                        className={`expln-guide__sect is-${section.type || "summary"}`}
                        key={`${section.type}-${section.title}-${sectionIndex}`}
                    >
                        {(guide.id === "notice" || section.type) && (
                            <h3 className="expln-guide__subtit">{section.title}</h3>
                        )}

                        <ul className="expln-guide__desc-list">
                            {section.items.map((description, itemIndex) => {
                                const item = typeof description === "string" ? { text: description } : description;

                                const displayType =
                                    item.displayType ||
                                    (isNoticeGuide || section.type === "path" || section.type === "reference"
                                        ? "list"
                                        : "text");

                                return (
                                    <li
                                        className={`expln-guide__desc-item is-${displayType}`}
                                        key={`${item.text}-${itemIndex}`}
                                    >
                                        {renderLineBreaks(item.text)}
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                ))}
            </div>
        </>
    );
}

function createOrderedSections(guide) {
    const isNoticeGuide = guide.mission === null;

    const sections = guide.sections.reduce((result, section) => {
        const isPathText = section.type === "path-text";
        const isPathWarning = section.type === "path-warning";

        if (!isNoticeGuide && (isPathText || isPathWarning)) {
            const pathSection = result.find((item) => item.type === "path");

            if (pathSection) {
                pathSection.items.push(
                    ...section.items.map((text) => ({
                        text,
                        displayType: isPathWarning ? "warning" : "text",
                    })),
                );

                return result;
            }
        }

        result.push({
            ...section,
            items: [...section.items],
        });

        return result;
    }, []);

    if (isNoticeGuide) {
        return sections;
    }

    return [
        ...sections.filter((section) => section.type !== "path"),
        ...sections.filter((section) => section.type === "path"),
    ];
}

function formatSubtitle(subtitle = "") {
    return subtitle.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\n/g, "<br>");
}
/** 안내 문구는 줄바꿈(\n)과 **강조** 표기를 지원한다. */
function renderLineBreaks(text = "") {
    return text.split("\n").map((line, index) => (
        <React.Fragment key={`${line}-${index}`}>
            {index > 0 && <br />}
            {renderBoldText(line, index)}
        </React.Fragment>
    ));
}

function renderBoldText(line = "", lineIndex = 0) {
    return line.split(/\*\*(.+?)\*\*/g).map((chunk, chunkIndex) =>
        chunkIndex % 2 === 1 ? (
            <strong className="expln-guide__desc-strong" key={`bold-${lineIndex}-${chunkIndex}`}>
                {chunk}
            </strong>
        ) : (
            <React.Fragment key={`text-${lineIndex}-${chunkIndex}`}>{chunk}</React.Fragment>
        ),
    );
}

export default ExamPlanGuide;
